// deriveProgressForChart.ts
type Summary = {
  done: number
  inProgress: number
  needsReview: number
  needMoreInfo: number
  notStarted: number
  onHold: number
  total: number
  source: 'summary' | 'progress' | 'checklist' | 'none'
}

const num = (v: any) => (typeof v === 'number' ? v : Number(v) || 0)
const sum = (o: Record<string, number>) => Object.values(o).reduce((a, b) => a + b, 0)

export function deriveProgressForChart(row: any): Summary {
  // 1) Prefer a non-empty progressSummary (legacy)
  const s = row?.progressSummary || {}
  const summaryCounts = {
    done: num(s.done),
    inProgress: num(s.inProgress),
    needsReview: num(s.needsReview),
    needMoreInfo: num(s.needMoreInfo),
    notStarted: num(s.notStarted),
    onHold: num(s.onHold),
  }
  const summaryTotal = num(s.total)
  const summarySum = sum(summaryCounts)

  if (summaryTotal > 0 && (summarySum > 0 || summaryTotal === summarySum)) {
    return { ...summaryCounts, total: summaryTotal, source: 'summary' }
  }

  // 2) Then compact task.progress (new checklist tasks often have this)
  const p = row?.progress
  const pTotal = num(p?.total)
  const pDone = num(p?.done)

  if (pTotal > 0) {
    return {
      done: pDone,
      inProgress: 0,
      needsReview: 0,
      needMoreInfo: 0,
      onHold: 0,
      notStarted: Math.max(0, pTotal - pDone),
      total: pTotal,
      source: 'progress',
    }
  }

  // 3) Finally compute from checklist
  const list = Array.isArray(row?.checklist) ? row.checklist : []
  if (list.length > 0) {
    const done = list.filter((i: any) => !!i?.done).length
    const total = list.length
    return {
      done,
      inProgress: 0,
      needsReview: 0,
      needMoreInfo: 0,
      onHold: 0,
      notStarted: Math.max(0, total - done),
      total,
      source: 'checklist',
    }
  }

  // 4) Nothing available
  return {
    done: 0,
    inProgress: 0,
    needsReview: 0,
    needMoreInfo: 0,
    onHold: 0,
    notStarted: 0,
    total: 0,
    source: 'none',
  }
}
